/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentArtifactsControllerFindAllByDocumentQueryResponse, DocumentArtifactsControllerFindAllByDocumentPathParams, DocumentArtifactsControllerFindAllByDocumentQueryParams, DocumentArtifactsControllerFindAllByDocument404 } from "../../models/documentArtifactsController/DocumentArtifactsControllerFindAllByDocument";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentArtifactsControllerFindAllByDocument } from "../../clients/document-artifactsService/documentArtifactsControllerFindAllByDocument";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentArtifactsControllerFindAllByDocumentQueryKey = (documentId: DocumentArtifactsControllerFindAllByDocumentPathParams["documentId"], params: DocumentArtifactsControllerFindAllByDocumentQueryParams) => [{
  url: '/api/v1/documents/:documentId/artifacts',
  params: {
    documentId: documentId
  }
}, ...(params ? [params] : [])] as const;
export type DocumentArtifactsControllerFindAllByDocumentQueryKey = ReturnType<typeof documentArtifactsControllerFindAllByDocumentQueryKey>;
export function documentArtifactsControllerFindAllByDocumentQueryOptions(documentId: DocumentArtifactsControllerFindAllByDocumentPathParams["documentId"], params: DocumentArtifactsControllerFindAllByDocumentQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentArtifactsControllerFindAllByDocumentQueryKey(documentId, params);
  return queryOptions<DocumentArtifactsControllerFindAllByDocumentQueryResponse, ResponseErrorConfig<DocumentArtifactsControllerFindAllByDocument404>, DocumentArtifactsControllerFindAllByDocumentQueryResponse, typeof queryKey>({
    enabled: !!(documentId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentArtifactsControllerFindAllByDocument(documentId, params, config);
    }
  });
}

/**
 * @description Returns all artifacts for a document, organized by their parent renditions. Provides a document-centric view of all artifacts.
 * @summary List all artifacts for a document grouped by rendition
 * {@link /api/v1/documents/:documentId/artifacts}
 */
export function useDocumentArtifactsControllerFindAllByDocument<TData = DocumentArtifactsControllerFindAllByDocumentQueryResponse, TQueryData = DocumentArtifactsControllerFindAllByDocumentQueryResponse, TQueryKey extends QueryKey = DocumentArtifactsControllerFindAllByDocumentQueryKey>(documentId: DocumentArtifactsControllerFindAllByDocumentPathParams["documentId"], params: DocumentArtifactsControllerFindAllByDocumentQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentArtifactsControllerFindAllByDocumentQueryResponse, ResponseErrorConfig<DocumentArtifactsControllerFindAllByDocument404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentArtifactsControllerFindAllByDocumentQueryKey(documentId, params);
  const query = useQuery({
    ...documentArtifactsControllerFindAllByDocumentQueryOptions(documentId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentArtifactsControllerFindAllByDocument404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}